export enum ScoreTypeEnum {
    GOLS = 'GOLS',
    PONTOS = 'PONTOS',
    KG = 'KG',
    METROS = 'METROS',
    TEMPO = 'TEMPO'
}
